<template>
  <div>
    <a-modal :visible="visible" title="新建子任务" width="750px" @cancel="onCloseModel" @ok="confirm">
      <div style="margin-top: 20px;">
        <a-form-model ref="form" :model="form" :wrapper-col="{ span: 16 }">
          <!-- 检测人员 -->
          <div style="display: flex;flex-direction: row;">
            <div style="width: 300px;display: flex;align-items: center;">
              <a style="color: black;flex-shrink: 0">检测人员：</a>
              <a-select v-model="form.person" style="width: 100%">
                <a-select-option v-for="item in userlist" :key="item.id" :value="item.username">
                  {{ item.username }}
                </a-select-option>
              </a-select>
            </div>

            <!-- 拍照次数 -->
            <div style="width: 300px;display: flex;align-items: center;margin-left: 30px;">
              <a style="color: black;flex-shrink: 0">拍照次数：</a>
              <a-input v-model="form.cnt" allowClear />
            </div>
          </div>

          <!-- 采集方式 -->
          <div style="display: flex;flex-direction: row;margin-top: 10px;">
            <div style="width: 300px;display: flex;align-items: center;">
              <a style="color: black;flex-shrink: 0">采集方式：</a>
              <a-select v-model="form.collection_method" style="width: 100%" placeholder="请选择采集方式">
                <a-select-option value="fixed_spacing">固定间距采样</a-select-option>
                <a-select-option value="dense_sampling">整体密集采样</a-select-option>
                <a-select-option value="random_sampling">随机采样</a-select-option>
              </a-select>
            </div>
            <!-- 备注信息 -->
            <div style="width: 300px;display: flex;align-items: center;margin-left: 30px;">
              <a style="color: black;flex-shrink: 0">备注信息：</a>
              <a-input v-model="form.beizhu" allowClear />
            </div>
          </div>
        </a-form-model>
      </div>

      <a-divider orientation="center">点击选择检测范围</a-divider>
      <div style="display: flex;justify-content: space-between;">
        <div>
          <a-col :span="24" style="width: 256px;">
            <a-input v-model="search_content" placeholder="地点名称、道路名" allowClear @pressEnter="search" />
          </a-col>
          <a-space style="margin-left: 10px">
            <a-button type="primary" icon="search" @click="search">查询</a-button>
          </a-space>
        </div>

        <a-space style="" v-if="show_search">
          <a-button type="warn" @click="close_search">关闭搜索</a-button>
        </a-space>
      </div>
      <div style="margin-top: 10px;width: 100%;text-align: center">
        <a>使用左键绘制路径</a>
      </div>

      <div id="container" style="margin-top: 10px;padding: 10px;"></div>
      <div id="panel" v-if="show_search"></div>

    </a-modal>

  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import { GetDistance } from "@/components/map/distance";

export default {
  props: ['visible', 'form', 'userlist', 'city', 'position', 'is_change_city'],
  model: { prop: 'visible', event: 'cancel' },
  data() {
    return {
      search_content: '',
      show_search: false,
      market: null,
      map: null,
      all_features: [],
      AMap: null,
      geocoder: null, // 地理编码器实例
      currentAddress: '', // 当前地址
      currentLocation: null, // 当前精确位置
    }
  },
  mounted() {

  },
  methods: {
    init() {
      AMapLoader.load({
        key: "94c008487c6ac7665d114c61eafe5cd1",
        version: "2.0",
        plugins: ['AMap.Geocoder'], // 添加地理编码插件
      })
          .then((AMap) => {
            this.AMap = AMap;
            // 初始化地理编码器
            this.geocoder = new this.AMap.Geocoder({
              city: '', // 全国范围
              radius: 1000
            });

            this.map = new this.AMap.Map("container", {
              resizeEnable: true,
              zoom: 15,
              mapStyle: "amap://styles/fresh"
            });

            // 监听地图点击事件
            this.map.on('click', this.onClick_map);

            // 先获取精确位置，再设置地图
            this.getPreciseLocation();
          })
          .catch((e) => {
            console.log(e);
            this.$message.error('地图加载失败');
          });
    },

    // 获取精确位置
    async getPreciseLocation() {
      try {
        // 根据传入的省市县信息获取精确位置
        if (this.city && (this.city.district || this.city.city || this.city.province)) {
          await this.geocodeAddress();
        } else if (this.position && this.position.lng && this.position.lat) {
          // 如果有传入的位置，使用传入的位置
          this.currentLocation = [this.position.lng, this.position.lat];
          this.setMapCenter(this.currentLocation, '传入的位置');
        } else {
          // 都没有则使用默认位置
          this.setDefaultLocation();
        }
      } catch (error) {
        console.error('获取位置失败:', error);
        this.setDefaultLocation();
      }
    },

    // 地理编码获取精确位置
    async geocodeAddress() {
      return new Promise((resolve, reject) => {
        // 构建地址字符串
        let address = '';
        if (this.city.district) {
          address = this.city.district;
        } else if (this.city.city) {
          address = this.city.city;
        } else if (this.city.province) {
          address = this.city.province;
        }

        if (!address) {
          reject(new Error('地址信息为空'));
          return;
        }

        // 尝试获取更详细的地址
        let fullAddress = '';
        if (this.city.province && this.city.city && this.city.district) {
          fullAddress = this.city.province + this.city.city + this.city.district;
        } else {
          fullAddress = address;
        }

        console.log('正在地理编码地址:', fullAddress);

        this.geocoder.getLocation(fullAddress, (status, result) => {
          if (status === 'complete' && result.geocodes.length > 0) {
            const location = result.geocodes[0].location;
            this.currentLocation = [location.lng, location.lat];
            this.currentAddress = result.geocodes[0].formattedAddress || fullAddress;

            console.log('地理编码成功:', {
              地址: fullAddress,
              经纬度: this.currentLocation,
              详细地址: this.currentAddress
            });

            // 设置地图中心
            this.setMapCenter(this.currentLocation, fullAddress + '中心');

            // 更新备注信息
            this.updateBeizhu();
            resolve();
          } else {
            console.log('地理编码失败:', status, result);
            // 尝试使用更简单的地址
            this.geocoder.getLocation(address, (status2, result2) => {
              if (status2 === 'complete' && result2.geocodes.length > 0) {
                const location = result2.geocodes[0].location;
                this.currentLocation = [location.lng, location.lat];
                this.currentAddress = result2.geocodes[0].formattedAddress || address;

                console.log('简化地址地理编码成功:', {
                  地址: address,
                  经纬度: this.currentLocation,
                  详细地址: this.currentAddress
                });

                this.setMapCenter(this.currentLocation, address + '中心');
                this.updateBeizhu();
                resolve();
              } else {
                console.log('简化地址地理编码也失败');
                this.setDefaultLocation();
                reject(new Error('地理编码失败'));
              }
            });
          }
        });
      });
    },

    // 设置地图中心
    setMapCenter(location, title) {
      this.map.setCenter(location);

      // 添加位置标记
      const marker = new this.AMap.Marker({
        icon: "https://vkceyugu.cdn.bspapp.com/VKCEYUGU-d5830f51-39c0-4186-a17c-0dc474d1e15b/24539d81-2e6a-452b-a8ff-293454c9bf4e.png",
        position: location,
        anchor: 'center',
        title: title,
        zIndex: 100
      });

      // 添加信息窗口
      const infoWindow = new this.AMap.InfoWindow({
        content: `<div style="padding: 5px;">
                  <div><strong>${title}</strong></div>
                  <div>经度: ${location[0].toFixed(6)}</div>
                  <div>纬度: ${location[1].toFixed(6)}</div>
                  ${this.currentAddress ? `<div>地址: ${this.currentAddress}</div>` : ''}
                </div>`,
        offset: new this.AMap.Pixel(0, -30)
      });

      marker.on('click', () => {
        infoWindow.open(this.map, location);
      });

      this.map.add(marker);

      // 立即打开信息窗口
      setTimeout(() => {
        infoWindow.open(this.map, location);
      }, 500);
    },

    // 设置默认位置
    setDefaultLocation() {
      const defaultLocation = [116.397428, 39.90923]; // 北京天安门
      this.currentLocation = defaultLocation;
      this.setMapCenter(defaultLocation, '默认位置');
      this.$message.warning('无法获取精确位置，已使用默认位置');
    },

    // 更新备注信息
    updateBeizhu() {
      let addressInfo = '';
      if (this.city.province) addressInfo += this.city.province;
      if (this.city.city) addressInfo += this.city.city;
      if (this.city.district) addressInfo += this.city.district;

      this.form.beizhu = addressInfo;
    },

    add_marker(e) {
      var marker = new this.AMap.Marker({
        icon: "https://vkceyugu.cdn.bspapp.com/VKCEYUGU-d5830f51-39c0-4186-a17c-0dc474d1e15b/6b56cb4a-0fc5-4bf5-bad5-7014bae17c89.png",
        position: e,
        anchor: 'center',
        title: (this.form.all_marker.length + 1)
      });
      this.map.add(marker);
      this.form.all_marker.push(e);
      this.all_features.push(marker);

      var that = this;
      marker.on('click', function () {
        console.log('click marker');
        that.change_line(marker.getTitle());
      });
    },
    change_line(e) {
      var that = this;
      that.form.all_marker.splice(e - 1, 1);
      // remove all
      for (var i = 0; i < that.all_features.length; i++) {
        that.map.remove(that.all_features[i]);
      }

      that.all_features = [];
      that.form.all_line = [];
      this.form.all_distance = [0];
      var length = that.form.all_marker.length
      // add_line
      for (var i = 1; i < length; i++) {
        var path = [that.form.all_marker[i - 1], that.form.all_marker[i]];
        var distance = GetDistance(path);
        var polyline = new this.AMap.Polyline({
          path: path,
          isOutline: true,
          outlineColor: '#ffeeff',
          borderWeight: 2,
          strokeColor: "#3366FF",
          strokeOpacity: 1,
          strokeWeight: 6,
          // 折线样式还支持 'dashed'
          strokeStyle: "solid",
          // strokeStyle是dashed时有效
          strokeDasharray: [10, 5],
          lineJoin: 'round',
          lineCap: 'round',
          zIndex: 50,
        });
        this.form.all_line.push(path);
        this.form.all_distance.push(distance);
        this.all_features.push(polyline);
        this.map.add(polyline);
      }
      // add marker
      for (var i = 0; i < length; i++) {
        var marker = new this.AMap.Marker({
          icon: "https://vkceyugu.cdn.bspapp.com/VKCEYUGU-d5830f51-39c0-4186-a17c-0dc474d1e15b/6b56cb4a-0fc5-4bf5-bad5-7014bae17c89.png",
          position: this.form.all_marker[i],
          anchor: 'center',
          title: (i + 1)
        });
        this.map.add(marker);
        this.all_features.push(marker);

        marker.on('click', function (e) {
          console.log('click new marker ');
          that.change_line(e.target._opts.title);
        });
      }
      // add label
      for (var i = 0; i < length; i++) {
        var labelMarker = new this.AMap.LabelMarker({
          position: this.form.all_marker[i],
          opacity: 1,
          zIndex: 2,
          text: {
            content: this.form.all_distance[i] ? (this.form.all_distance[i] + 'KM') : '起点',
            direction: 'right',
            offset: [10, 0],
            style: {
              fontSize: 13,
              color: 'black',
              strokeWidth: 2,
              padding: [2, 8],
              backgroundColor: '#b6b6b6'
            }
          }
        });
        this.map.add(labelMarker);
        this.all_features.push(labelMarker);
      }
    },
    add_line() {
      if (this.form.all_marker.length != 1) {
        var length = this.form.all_marker.length;
        var path = [this.form.all_marker[length - 1], this.form.all_marker[length - 2]];
        var distance = GetDistance(path);
        var polyline = new this.AMap.Polyline({
          path: path,
          isOutline: true,
          outlineColor: '#ffeeff',
          borderWeight: 2,
          strokeColor: "#3366FF",
          strokeOpacity: 1,
          strokeWeight: 6,
          // 折线样式还支持 'dashed'
          strokeStyle: "solid",
          // strokeStyle是dashed时有效
          strokeDasharray: [10, 5],
          lineJoin: 'round',
          lineCap: 'round',
          zIndex: 50,
        });
        this.form.all_line.push(path);
        this.all_features.push(polyline);
        this.form.all_distance.push(distance);
        this.map.add(polyline);
      } else {
        this.form.all_distance.push(0);
      }
    },
    add_label(e) {
      var labelMarker = new this.AMap.LabelMarker({
        position: e,
        opacity: 1,
        zIndex: 2,
        text: {
          content: this.form.all_marker.length != 1 ? (this.form.all_distance[this.form.all_distance.length - 1] + 'KM') : '起点',
          direction: 'right',
          offset: [10, 0],
          style: {
            fontSize: 13,
            color: 'black',
            strokeWidth: 2,
            padding: [2, 8],
            backgroundColor: '#b6b6b6'
          }
        }
      });
      this.map.add(labelMarker);
      this.all_features.push(labelMarker);
    },
    onClick_map(e) {
      this.add_marker(e.lnglat);
      this.add_line();
      this.add_label(e.lnglat);
    },
    close_search() {
      this.show_search = false;
    },
    search() {
      var content = this.search_content;
      var that = this;
      this.AMap.plugin(["AMap.PlaceSearch"], function () {
        //构造地点查询类
        var placeSearch = new that.AMap.PlaceSearch({
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码
          city: that.city.city, // 兴趣点城市
          citylimit: true,  //是否强制限制在设置的城市内搜索
          map: that.map, // 展现结果的地图实例
          panel: "panel", // 结果列表将在此容器中进行展示。
          autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        });
        //关键字查询
        placeSearch.search(content);
        that.show_search = true;
      });
    },

    onCloseModel() {
      if (this.map != null) this.map.destroy();
      this.$emit('cancel', false);
    },
    confirm() {
      if (this.map != null) this.map.destroy();
      this.$emit('confirm', true);
    },
    resetModel() {
      this.form.person = this.$store.state.user.username;
      this.form.beizhu = '';
      this.form.name = '';
      this.form.all_line = [];
      this.form.all_marker = [];
      this.form.all_distance = [];
      this.form.collection_method = ''; // 重置采集方式
      this.currentAddress = '';
      this.currentLocation = null;
    },
  },
  watch: {
    visible(status) {
      if (status) {
        this.init();
        this.resetModel();
      }
    },
  },
}
</script>

<style>

#container {
  width: 100%;
  height: 420px;
  height: 420px;
}

#panel {
  position: absolute;
  background-color: white;
  height: 420px;
  overflow-y: auto;
  top: 300px;
  right: 10px;
  width: 300px;
}

@media (max-width: 768px) {
  #container {
    height: 360px;
    padding: 0 !important;
  }

  #panel {
    position: static;
    width: 100%;
    height: 220px;
    margin-top: 8px;
  }
}
</style>
